/**
 * Import des styles
 * ****************************************
 */
import "./sass/main.scss";
/**
 * Import des modules
 * ****************************************
 */

import RecipesFilters from "./ts/modules/RecipesFilters";
import Menu from "./ts/modules/Menu";
import VideoPopups from "./ts/modules/VideoPopups";
import Slider from "./ts/modules/Sliders";
import Features from "./ts/modules/Product";


/**
 * Initialisation des modules
 * ******************************
 */
window.onload = () => {
	/**
	 * Gestion des filtres de la page "recettes"
	 * ******************************
	 */
	RecipesFilters();

	/**
	 * Gestion des sous-menus
	 * ******************************
	 */
	Menu();

	/**
	 * Gestion des popups "video"
	 * ******************************
	 */
	VideoPopups();

	/**
	 * Gestion des sliders
	 * ******************************
	 */
	Slider();

	/**
	 * Gestion des onglets features de la page produit
	 * ******************************
	 */
	Features();
};
